import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
const START_LEFT = 9;
const MIN_LEFT = 3;
const STEP_MS = 45000;
// Shared start so every bar on the page shows the same count.
const START = Date.now();
function spotsLeft(): number {
  return Math.max(MIN_LEFT, START_LEFT - Math.floor((Date.now() - START) / STEP_MS));
}
export function ScarcityBar() {
  const [left, setLeft] = useState(spotsLeft);
  useEffect(() => {
    const id = window.setInterval(() => setLeft(spotsLeft()), 1000);
    return () => window.clearInterval(id);
  }, []);
  const pct = (TOTAL_SPOTS - left) / TOTAL_SPOTS * 100;
  return <div className="rounded-xl border border-signal/50 bg-[#1A0B0E] p-4" data-id="element-285" data-mp="274d9nwwd8arq">
      <p className="flex items-center justify-center gap-2 text-center text-[15px] font-bold text-white" data-id="element-286" data-mp="ep51pxth8r6">
        <FlameIcon className="h-5 w-5 shrink-0 text-signal" aria-hidden="true" data-id="element-287" data-mp="5di9ytz1frfq" />
        <span data-id="element-288" data-mp="5bfjy9xvxyb0">
          Only <span className="text-[#FF6B66]" data-id="element-289" data-mp="33md2x11rxsn9">{left} spots left</span> at the promotional price
        </span>
      </p>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-[#3A1418]" role="progressbar" aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-290" data-mp="2zm2xbphw948x">
        <motion.div className="h-full rounded-full bg-signal" initial={false} animate={{
        width: `${pct}%`
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-291" data-mp="2ko0szd31geqm" />
      </div>
      <p className="mt-2 text-center text-xs font-semibold uppercase tracking-wide text-[#FF8C88]" data-id="element-292" data-mp="2umgl9jdsxu1p">
        {Math.round(pct)}% claimed — price goes up when spots run out
      </p>
    </div>;
}